<div class="content" [innerHTML]="transform(question.options.html)"></div>